<template>
	<div class="card h-100">
		<div class="card-body vstack gap-2" :class="{ 'placeholder-glow': placeholder }">
			<div class="h6 text-muted placeholder col-8 col-md-4" v-if="placeholder"></div>
			<router-link :to="link" class="h6 text-muted stretched-link" v-else-if="link && title">{{ title }}</router-link>
			<div class="h6 text-muted" :class="{ 'placeholder col-8 col-md-4': placeholder }" v-else-if="title">{{ (placeholder) ? '' : title }}</div>
			<div class="vstack gap-1">
				<div class="vstack gap-1" v-if="placeholder">
					<span class="text-sm text-muted text-opacity-90 lh-xs fw-semibold placeholder col-2 col-md-1"></span>
					<span class="h3 lh-xs ls-tight fw-bold placeholder col-8 col-md-4"></span>
				</div>
				<div class="vstack" v-for="(info, index) in data" :key="index" v-else>
					<span class="text-sm text-muted text-opacity-90 lh-xs fw-semibold">{{ info.title }}</span>
					<span class="h3 lh-xs ls-tight fw-bold">{{ vueNumberFormat(info.amount, { suffix: info.suffix ?? '', precision: info.precision ?? 0 }) }}</span>
				</div>
				<div class="vstack gap-1" v-if="placeholder">
					<div class="text-muted text-xs text-opacity-80 lh-xs placeholder col-10 col-md-5"></div>
				</div>
				<div class="vstack gap-1" v-else>
					<div class="text-muted text-xs text-opacity-80 lh-xs" v-html="description" v-if="description"></div>
					<div class="hstack gap-3 lh-1 align-items-center mt-auto" v-if="progress">
						<div class="progress flex-fill h-rem-2" role="progressbar" aria-label="Basic example">
							<div class="progress-bar" :style="{ width: `${progress.percentage}%` }"></div>
						</div>
						<span class="text-muted text-xs fw-semibold">{{ vueNumberFormat(progress.percentage, { suffix: ' %', precision: progress.precision ?? 0 }) }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			placeholder: {
				type: Boolean,
				default: false
			},
			link: Object,
			title: String,
			data: Array,
			description: String,
			progress: Object
		}
	}
</script>